export enum ConsentType {
  NECESSARY = 'cookie_cat_necessary',
  STATISTIC = 'cookie_cat_statistic',
}
